import { atom } from 'jotai';
import type { NotificationRow } from './types';

/**
 * The badge count lives here rather than in the bell component because more than one thing
 * changes it: the poll, a click on a row, and mark-all-read — and mark-all-read can happen
 * from the full page, which is not in the bell's tree.
 */
export const unreadCountAtom = atom(0);

/**
 * What the bell actually displays. Separate from unread: opening the panel clears this
 * without marking anything read, which is how every notification UI people already use
 * behaves.
 */
export const unseenCountAtom = atom(0);

/** Rows shown in the dropdown. The full page keeps its own paged list. */
export const notificationsAtom = atom<NotificationRow[]>([]);

/** Whether the dropdown is open. Owned here so the bell and the panel stay siblings. */
export const isNotificationPanelOpenAtom = atom(false);
